import { Field, FieldProps, useControlId } from './Field'

export type SelectOption = { value: string | number; label: string }

export function SelectField({
  label,
  error,
  hint,
  labelStyle,
  className,
  style,
  id,
  value,
  onChange,
  options,
  placeholder,
  controlClassName = '',
  controlStyle,
  ...rest
}: FieldProps & {
  value: string | number
  onChange: (value: string) => void
  options: readonly SelectOption[]
  placeholder?: string
  controlClassName?: string
  controlStyle?: React.CSSProperties
} & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange' | 'id' | 'className' | 'style'>) {
  const controlId = useControlId(id)

  return (
    <Field label={label} error={error} hint={hint} labelStyle={labelStyle} className={className} style={style} controlId={controlId}>
      <select
        id={controlId}
        className={`form-control ${controlClassName}`.trim()}
        style={controlStyle}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        {...rest}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </Field>
  )
}
